import { createSlice } from "@reduxjs/toolkit";

const initialState: DetailState<IPdu> = {
  data: null,
  pageSize: 0,
  pageNumber: 0,
  totalCount: 0,
  showLoading: {
    sourceAction: "",
    state: false,
  },
  isLoading: false,
  isSuccess: false,
  details: null,
};

export const pduSlice = createSlice({
  name: "pdu",
  initialState,
  reducers: {
    setLoading: (state, action) => {
      const { sourceAction, isLoading, isSuccess } = action.payload;
      state.showLoading = {
        sourceAction: sourceAction,
        state: true,
      };
      state.isLoading = isLoading ? isLoading : false;
      state.isSuccess = isSuccess ? isSuccess : false;
    },
    resetLoading: (state, action) => {
      const { isLoading, isSuccess } = action.payload;
      state.showLoading = {
        sourceAction: "",
        state: false,
      };
      state.isLoading = isLoading ? isLoading : false;
      state.isSuccess = isSuccess ? isSuccess : false;
    },
    replacePdu: (state, action) => {
      const { data, pageSize, pageNumber, totalCount } = action.payload;
      state.data = data;
      state.pageSize = pageSize;
      state.pageNumber = pageNumber;
      state.totalCount = totalCount;
    },
    addPdu: (state, action) => {
      const newItem = action.payload.data;
      if (state.data && state.data.length > state.pageSize) {
        state.data.pop();
      }
      state.data = state.data ? [newItem, ...state.data] : [newItem];
      state.totalCount = state.totalCount + 1;
    },
    updatePdu: (state, action) => {
      const { localID, data } = action.payload;
      if (localID !== undefined && localID >= 0 && state.data) {
        state.data[localID] = data;
      }
      state.details = data;
    },
    deletePdu: (state, action) => {
      const pduToRemove: IPdu = action.payload.data;
      const newPduData =
        state.data &&
        state.data.filter((pdu: IPdu) => {
          return pdu.id !== pduToRemove.id;
        });
      state.data = newPduData;
      state.totalCount = state.totalCount - 1;
    },
    setPduDetails: (state, action) => {
      state.details = action.payload.data;
    },
  },
});

export const pduActions = pduSlice.actions;
export default pduSlice.reducer;
